import React from 'react';
import Icon from '../Icon/Icon';
import { AssistantTraceStep } from './traceSteps';

interface AssistantTraceProps {
  steps: AssistantTraceStep[];
  activeIndex: number;
  done?: boolean;
}

const AssistantTrace: React.FC<AssistantTraceProps> = ({ steps, activeIndex, done }) => {
  if (!steps.length) return null;
  return (
    <ol className={`assistant-trace${done ? ' is-done' : ' is-live'}`} aria-live="polite">
      {steps.map((step, index) => {
        const state = done
          ? 'done'
          : step.state || (index < activeIndex ? 'done' : index === activeIndex ? 'run' : 'wait');
        const details = (step.details || []).filter(Boolean).slice(0, 6);
        return (
          <li key={`${step.id}-${index}`} className={`assistant-trace__item is-${state}`}>
            <span className="assistant-trace__mark" aria-hidden>
              {state === 'done' ? (
                <Icon name="check" size={9} />
              ) : state === 'run' ? (
                <Icon name="loader" size={9} />
              ) : null}
            </span>
            <span className="assistant-trace__body">
              <span>{step.label}</span>
              {details.length > 0 && state === 'done' && (
                <ul className="assistant-trace__details">
                  {details.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              )}
            </span>
          </li>
        );
      })}
    </ol>
  );
};

export default AssistantTrace;
